import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Card, Typography, Avatar, Space } from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  CalendarOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import "./Home.css";
import { Typewriter } from "react-simple-typewriter";
import { useNavigate } from "react-router-dom";
import { URL } from "../config";
const { Header, Content, Footer } = Layout;
const { Title } = Typography;


export default function Home() {
  const [ClinicName, setClinicName] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();


  useEffect(() => {
    const fetchClinic = async () => {
      try {
        const res = await fetch(`${URL}/clinicmasters`);
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          setClinicName(data[0].ClinicName);
        }
      } catch (e) {
        console.log("Clinic fetch error:", e);
      }
    };

    fetchClinic();
  }, []);


  useEffect(() => {
    const r = localStorage.getItem("userRole");
    if (!r) navigate("/");
    setRole(r);
  }, [navigate]);


  let menuCards = [
    {
      title: "Add Student",
      icon: <UserOutlined />,
      key: "patient",
      path: "registration",
      iconBg: "#fce3f2",    // फिकट निळा/तेली
      iconColor: "#a80678"
    },
    {
      title: "Student List",
      icon: <FileTextOutlined />,
      key: "casepaper",
      path: "member-list",
      iconBg: "#c4e2f8",    // फिकट रॉयल ब्लू
      iconColor: "#0865a3"
    },
    
    {
      title: "Logout",
      icon: <LogoutOutlined />,
      key: "logout",
      path: "logout",
      iconBg: "#ffdddd",    // f1b65c प्रमाणे फिकट लाल
      iconColor: "#eb210a"
    },
  ];


  if (role === "receptionist") {
    menuCards = menuCards.filter((c) => c.key !== "appointments");
  }


  if (role === "doctor") {
    menuCards = menuCards.filter((c) => c.key !== "casepaper");
  }


  const handleCardClick = (item) => {
    if (item.key === "logout") {
      localStorage.removeItem("userRole");
      localStorage.removeItem("token");
      navigate("/");
      return;
    }

    navigate(`/dashboard/${item.path}`);
  };

  return (
    <Layout className="site-layout">
      <Header className="site-header">
        <div className="header-inner">
          <Title level={2} className="brand-title">
            <Typewriter
              words={[`Welcome To Admin ${ClinicName}`]}
              loop={Infinity}
              cursor
              cursorStyle="_"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </Title>
        </div>

        <div className="hero-card-wrap">
          <div className="hero-card">
            <p className="hero-title">Education is the key to unlocking the world</p>
          </div>
        </div>
      </Header>

      <Content className="site-content">
        <div className="cards-container">
          <Row gutter={[32, 32]} justify="center">
            {/* तुमच्या मॅपिंग कोडमधील हा भाग असा बदला */}
            {menuCards.map((c) => (
              <Col xs={22} sm={12} md={8} lg={6} key={c.key}>
                <Card hoverable className="menu-card" onClick={() => handleCardClick(c)}>
                  <Space
                    direction="vertical"
                    size={16}
                    align="center"
                    style={{ width: "100%" }}
                  >
                    {/* 🟢 इथे बदल केला आहे: .icon-circle ला डायनॅमिक बॅकग्राउंड दिला */}
                    <div
                      className="icon-circle"
                      style={{
                        backgroundColor: c.iconBg,
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      {/* 🟢 आयकॉनला त्याचा योग्य कलर देण्यासाठी React.cloneElement वापरला */}
                      {React.cloneElement(c.icon, {
                        style: { fontSize: "24px", color: c.iconColor }
                      })}
                    </div>

                    <Title level={4} className="card-title">
                      {c.title}
                    </Title>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Content>

      <Footer className="site-footer">
        <div className="footer-inner">
          Designed & Developed By
          <span className="footer-highlight">
            Comtranse Technology Pvt.Ltd.
          </span>
        </div>
      </Footer>
    </Layout>
  );
}
